var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "lg", title: _vm.title, withBgClickEvent: "" },
    on: {
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "FormGroup",
              [
                _c("FormTextarea", {
                  staticClass: "mt-5",
                  attrs: {
                    rows: 10,
                    placeholder: "",
                    customBorderClass: "borderTen",
                  },
                  model: {
                    value: _vm.comment,
                    callback: function ($$v) {
                      _vm.comment = $$v
                    },
                    expression: "comment",
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }